import { render, staticRenderFns } from "./WarrantyDetails.vue?vue&type=template&id=16944221&scoped=true&"
import script from "./WarrantyDetails.vue?vue&type=script&lang=js&"
export * from "./WarrantyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16944221",
  null
  
)

export default component.exports